import {useMemo} from "react";
import {useSelector} from "react-redux";
import {selectUserId, selectUserRole} from "../../store/features/Auth/authSlice";
import {useFetchGroupsAdminQuery, useGroupsForFiltersQuery} from "../../store/features/groups/groupsService";

const GROUP_LIMIT = 1000;

/**
 * Resolves ENS target group IDs to their display names. Mirrors the wizard's
 * role-based source: admins read the full org group list, members read their own.
 */
export const useEnsGroupNames = (): Map<number, string> => {
    const userId = useSelector(selectUserId);
    const role = useSelector(selectUserRole);
    const isAdmin = role === 'ADMIN' || role === 'SUPERADMIN';

    const {data: userGroups} = useGroupsForFiltersQuery({userId}, {skip: isAdmin});
    const {data: adminGroups} = useFetchGroupsAdminQuery(
        {userId, phrase: '', limit: GROUP_LIMIT},
        {skip: !isAdmin},
    );

    return useMemo(() => {
        const map = new Map<number, string>();
        if (isAdmin) {
            adminGroups?.groups.forEach(({group}) => map.set(group.groupId, group.name));
        } else {
            (userGroups ?? []).forEach((group) => map.set(group.groupId, group.name));
        }
        return map;
    }, [isAdmin, adminGroups, userGroups]);
};
